import React, { Component } from "react";
import { ToastContainer, toast } from "react-toastify";
import { SideBar, NavBar, Footer } from "../../components";
import "react-toastify/dist/ReactToastify.css";

class Home extends Component {
  constructor() {
    super();
    this.state = {
    };
  }

  async componentDidMount() {
  }

  render() {
    return (
      <React.Fragment>
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnVisibilityChange
          draggable
          pauseOnHover
        />

        <div className="container-scroller font-app">
          <NavBar title="Home" />

          <div className="container-fluid page-body-wrapper">
            <SideBar itemActive={"home"} />

            <div className="main-panel">
              <div className="content-wrapper" style={{ marginBottom: "40px" }}>
                <div className="row">
                  <div className="col-md-12 grid-margin-box stretch-card">
                    <div className="card">
                      <div className="card-body dashboard-tabs p-0">
                        
                    
                      </div>
                    </div>
                  </div>
                </div>

              </div>
              <Footer />
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}
export default Home;
